// @ts-nocheck
export const localeCodes =  [
  "vi",
  "en"
]
export const localeLoaders = {
  vi: [
    {
      key: "locale_vi_46json_d7898ae4",
      load: () => import("#nuxt-i18n/d7898ae4" /* webpackChunkName: "locale_vi_46json_d7898ae4" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "vi",
    iso: "vi-VN",
    name: "Việt Nam",
    language: undefined
  },
  {
    code: "en",
    iso: "en-US",
    name: "English",
    language: undefined
  }
]
/** client **/

/** client-end **/